import SpriteSymbol from "../../../../../common/temp/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../tools/svg-sprite.js";
var symbol = new SpriteSymbol({
  "id": "icon-canceled-light",
  "use": "icon-canceled-light-usage",
  "viewBox": "0 0 11 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 11 11\" id=\"icon-canceled-light\"><circle cx=\"5.895\" cy=\"5.462\" r=\"4.5\" stroke=\"#ADB1B8\" /><path stroke=\"#ADB1B8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7.85 5.47H4.153\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol